"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _ReactPwaAlert = _interopRequireDefault(require("@micado-digital/react-pwa-alert/ReactPwaAlert"));
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _contactOverlay = _interopRequireDefault(require("../../components/contact-overlay"));
var _footer = _interopRequireDefault(require("../../components/footer"));
var _headerbar = _interopRequireDefault(require("../../components/headerbar"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    overflow: "hidden",
    minHeight: "100vh",
    padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
    position: "relative"
  },
  container: {
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4)
  },
  spacing: {
    paddingBottom: "calc(env(safe-area-inset-bottom) + 115px)"
  },
  spacingSocialMedia: {
    paddingBottom: "calc(env(safe-area-inset-bottom) + 227px)"
  }
}));
const LayoutStandard = _ref => {
  var _pageData$data, _pageData$data2, _pageData$data$meta, _pageData$data4, _pageData$data5, _pageData$data6, _pageData$data7, _pageData$data8, _pageData$data9, _pageData$data10, _pageData$data11;
  let {
    children,
    fullscreen = false,
    socialMedia = false
  } = _ref;
  const {
    REACT_APP_PATH,
    REACT_APP_FOOTERNAV
  } = process.env;
  const [appData] = (0, _react.useContext)(_appContext.default);
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const {
    pwaShowInstallHint = false,
    pwaShowInstallHintReminder
  } = appData || {};
  const {
    menuGroups
  } = pageData.data;
  const ref = (0, _react.useRef)();
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();

  // search menu in page data

  const menuGroupForFooter = (0, _lodash.find)(menuGroups, function (o) {
    return o.title === REACT_APP_FOOTERNAV;
  });
  const handleOnScreen = isVisible => {
    if (!(ref !== null && ref !== void 0 && ref.current)) return;
    if (isVisible) {
      ref.current.style.opacity = 0;
    } else {
      ref.current.style.opacity = 1;
    }
  };
  if (pageData !== null && pageData !== void 0 && (_pageData$data = pageData.data) !== null && _pageData$data !== void 0 && _pageData$data.lang && (pageData === null || pageData === void 0 || (_pageData$data2 = pageData.data) === null || _pageData$data2 === void 0 ? void 0 : _pageData$data2.lang) !== i18n.language) {
    var _pageData$data3;
    (0, _changeLanguage.default)(i18n, pageData === null || pageData === void 0 || (_pageData$data3 = pageData.data) === null || _pageData$data3 === void 0 ? void 0 : _pageData$data3.lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    canonical: pageData === null || pageData === void 0 || (_pageData$data$meta = pageData.data.meta) === null || _pageData$data$meta === void 0 ? void 0 : _pageData$data$meta.canonical,
    description: pageData === null || pageData === void 0 || (_pageData$data4 = pageData.data) === null || _pageData$data4 === void 0 || (_pageData$data4 = _pageData$data4.meta) === null || _pageData$data4 === void 0 ? void 0 : _pageData$data4.description,
    index: pageData === null || pageData === void 0 || (_pageData$data5 = pageData.data) === null || _pageData$data5 === void 0 || (_pageData$data5 = _pageData$data5.meta) === null || _pageData$data5 === void 0 ? void 0 : _pageData$data5.indexable,
    image: pageData === null || pageData === void 0 || (_pageData$data6 = pageData.data) === null || _pageData$data6 === void 0 || (_pageData$data6 = _pageData$data6.meta) === null || _pageData$data6 === void 0 ? void 0 : _pageData$data6.image,
    keywords: pageData === null || pageData === void 0 || (_pageData$data7 = pageData.data) === null || _pageData$data7 === void 0 || (_pageData$data7 = _pageData$data7.meta) === null || _pageData$data7 === void 0 ? void 0 : _pageData$data7.keywords,
    lat: pageData === null || pageData === void 0 || (_pageData$data8 = pageData.data) === null || _pageData$data8 === void 0 || (_pageData$data8 = _pageData$data8.meta) === null || _pageData$data8 === void 0 ? void 0 : _pageData$data8.lat,
    lang: pageData === null || pageData === void 0 ? void 0 : pageData.data.lang,
    links: pageData === null || pageData === void 0 || (_pageData$data9 = pageData.data) === null || _pageData$data9 === void 0 || (_pageData$data9 = _pageData$data9.meta) === null || _pageData$data9 === void 0 ? void 0 : _pageData$data9.links,
    lng: pageData === null || pageData === void 0 || (_pageData$data10 = pageData.data) === null || _pageData$data10 === void 0 || (_pageData$data10 = _pageData$data10.meta) === null || _pageData$data10 === void 0 ? void 0 : _pageData$data10.lng,
    title: pageData === null || pageData === void 0 || (_pageData$data11 = pageData.data) === null || _pageData$data11 === void 0 || (_pageData$data11 = _pageData$data11.meta) === null || _pageData$data11 === void 0 ? void 0 : _pageData$data11.title
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)({
      [css.root]: true,
      [css.spacing]: true,
      [css.spacingSocialMedia]: socialMedia,
      [css.fullscreen]: fullscreen
    })
  }, /*#__PURE__*/_react.default.createElement(_headerbar.default, null), fullscreen ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)) : /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.container
  }, children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), /*#__PURE__*/_react.default.createElement(_footer.default, {
    menuGroup: menuGroupForFooter,
    socialMedia: socialMedia,
    onScreen: handleOnScreen
  }), pwaShowInstallHint && /*#__PURE__*/_react.default.createElement(_ReactPwaAlert.default, {
    appIcon: "".concat(REACT_APP_PATH, "/img/pwa/apple-icon-180.png"),
    checkCookie: false,
    lang: i18n.language,
    reminder: pwaShowInstallHintReminder
  }), /*#__PURE__*/_react.default.createElement(_contactOverlay.default, {
    fabButtonRef: ref
  })));
};
var _default = exports.default = LayoutStandard;